<template>
  <div class="header">
    <div
      :style="`background-color: ${backgroundColor}`"
      id="headerWrap"
      :class="
        isShow || backgroundColor !== 'transparent'
          ? 'header-wrap active'
          : 'header-wrap'
      "
    >
      <RouterLink to="/">
        <img
          v-if="backgroundColor === 'transparent'"
          class="logo"
          :src="
            isShow
              ? require('../../assets/img/top-main-logo.png')
              : require('../../assets/img/header_logo.png')
          "
          alt="잠자는국회 로고"
        />
        <img
          v-else
          class="logo"
          :src="require('../../assets/img/top-main-logo.png')"
          alt="잠자는국회 로고"
        />
      </RouterLink>
      <ul class="menu">
        <li>
          <RouterLink to="/about">잠자는 국회 | 입법평론</RouterLink>
        </li>
        <li @mouseover="isShow = true">
          <RouterLink to="/nth-national-assembly">22대 국회</RouterLink>
          <span v-if="isShow" class="active-bar"></span>
        </li>
        <li>
          <RouterLink to="/congressman-bill"
            >국회의원 1호 법안 상황판</RouterLink
          >
        </li>
        <li>
          <RouterLink to="/standing-committee-bill"
            >상임위원회 법안처리 현황</RouterLink
          >
        </li>
        <li>
          <button type="button" @click="rightMenuIconClick">
            <img
              class="menu-icon"
              :src="
                isShow || backgroundColor !== 'transparent'
                  ? require('../../assets/img/menu-active.png')
                  : require('../../assets/img/menu.png')
              "
              alt="메뉴"
            />
          </button>
        </li>
      </ul>
      <button
        class="menu-icon-mobile"
        type="button"
        @click="rightMenuIconClick"
      >
        <img
          v-if="isPc"
          class="menu-icon"
          :src="
            isShow || backgroundColor !== 'transparent'
              ? require('../../assets/img/menu-active-m.png')
              : require('../../assets/img/menu-m.png')
          "
          alt="메뉴"
        />
        <img
          v-else
          class="menu-icon"
          :style="
            isShow || backgroundColor !== 'transparent'
              ? 'width: 24px; height: 24px;'
              : 'width: 32px; height: 32px;'
          "
          :src="
            isShow || backgroundColor !== 'transparent'
              ? require('../../assets/img/menu-active.png')
              : require('../../assets/img/menu.png')
          "
          alt="메뉴"
        />
      </button>
    </div>
    <div v-if="isShow" @mouseleave="isShow = false" class="header-sub">
      <ul class="header-sub-menu">
        <li>
          <RouterLink to="/nth-national-assembly"
            >22대 국회 법안처리 현황판</RouterLink
          >
        </li>
        <li>
          <RouterLink to="/nth-national-assembly?type=congressman"
            >22대 국회의원 입법 현황판</RouterLink
          >
        </li>
      </ul>
    </div>
    <div class="right-menu" v-if="isRightMenuShow">
      <div class="right-menu-close-wrap">
        <button type="button" @click="isRightMenuShow = false">
          <img
            :src="require('../../assets/img/all-menu-close.png')"
            alt="메뉴 닫기"
          />
        </button>
      </div>
      <div class="right-menu-wrap">
        <button @click="moveToPage('/about')">잠자는 국회 | 입법평론</button>
        <button @click="moveToPage('/nth-national-assembly')">
          22대 국회 법안처리 현황판
        </button>
        <button @click="moveToPage('/nth-national-assembly?type=congressman')">
          22대 국회의원 입법 현황판
        </button>
        <button @click="moveToPage('/congressman-bill')">
          국회의원 1호 법안 상황판
        </button>
        <button @click="moveToPage('/standing-committee-bill')">
          상임위원회 법안처리 현황
        </button>
      </div>
    </div>
    <div
      v-if="isRightMenuShow"
      @click="isRightMenuShow = false"
      class="right-menu-bg"
    ></div>
  </div>
</template>

<script>
import { RouterLink } from "vue-router";

export default {
  name: "HeaderMenu",

  data() {
    return {
      isShow: false,
      isRightMenuShow: false,
      isPc: true,
      backgroundColor: "transparent",
    };
  },

  components: { RouterLink },

  mounted() {
    window.addEventListener("resize", this.checkScreenWidth);
    window.addEventListener("scroll", this.chnageBg);

    this.chnageBg();
    this.checkScreenWidth();
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.checkScreenWidth);
    window.removeEventListener("scroll", this.chnageBg);
  },

  methods: {
    chnageBg() {
      if (window.scrollY > 80) {
        this.backgroundColor = "#fff";
      } else {
        this.backgroundColor = "transparent";
      }
    },
    checkScreenWidth() {
      if (window.innerWidth <= 1040) {
        this.isPc = false;
      } else {
        this.isPc = true;
      }
    },
    moveToPage(to) {
      this.isRightMenuShow = false;
      this.$router.push(to);
    },
    rightMenuIconClick() {
      this.isShow = false;
      this.isRightMenuShow = true;
    },
  },
};
</script>

<style scoped>
.header {
  height: 76px;
  justify-content: space-between;
  width: 100%;
  position: absolute;
  z-index: 4;
  padding: 0 100px;
  border-bottom: 1px solid #fff;

  @media only screen and (max-width: 1040px) {
    height: 60px;
  }
}

.logo {
  height: 76px;

  @media only screen and (max-width: 1040px) {
    height: 60px;
  }
}

.header-wrap {
  align-items: center;
  display: flex;
  z-index: 3;
  left: 0;
  top: 0;
  justify-content: space-around;
  width: 100%;
  position: fixed;

  @media only screen and (max-width: 1040px) {
    justify-content: center;
  }
}

.menu {
  display: flex;
  gap: 63px;
  flex-direction: row;
  align-items: center;
  position: relative;
  height: 80px;

  & li a {
    font-size: 20px;
    color: #fff;
  }

  & li button {
    font-size: 20px;
    color: #fff;
  }

  @media only screen and (max-width: 1300px) {
    & li a {
      font-size: 16px;
    }

    & li button {
      font-size: 16px;
    }
  }

  @media only screen and (max-width: 1040px) {
    display: none;
  }
}

.header-wrap.active {
  border-bottom: 1px solid #ccc;

  & li a,
  & li button {
    color: #000;
  }
}

.menu-icon {
  width: 24px;
  height: 24px;
}

.menu-icon-mobile {
  display: none;
  position: absolute;
  right: 60px;

  @media only screen and (max-width: 1040px) {
    display: block;
  }
  @media only screen and (max-width: 480px) {
    right: 0;
  }
}

.active-bar {
  width: 86px;
  display: block;
  height: 6px;
  background: #005aab;
  position: absolute;
  bottom: 0;
}

.header-sub-menu {
  position: absolute;
  bottom: 0;
  padding: 40px 0;
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 30px;
  left: 40vw;

  & a {
    font-family: GmarketSansMedium;
    font-size: 20px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #666666;

    &:hover {
      color: #005aab;
    }
  }
}

.header-sub {
  width: 100%;
  height: 200px;
  background-color: #fff;
  position: fixed;
  z-index: 2;
  left: 0;
  top: 0;
}

.right-menu {
  position: fixed;
  height: 100%;
  width: 440px;
  padding: 40px 40px 0 79px;
  background-color: #fff;
  right: 0;
  top: 0;
  z-index: 4;
  background-color: #fff;

  @media only screen and (max-width: 440px) {
    width: 100%;
    padding: 40px 40px 0 40px;
  }
}

.right-menu-bg {
  width: 100%;
  height: 100%;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.3);
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
}

.right-menu-close-wrap {
  text-align: right;
}

.right-menu-wrap {
  margin-top: 36px;
  display: flex;
  flex-direction: column;
  gap: 59px;

  & button {
    font-family: GmarketSansMedium;
    font-size: 24px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #7d7d7d;
  }

  @media only screen and (max-width: 440px) {
    & button {
      font-size: 19px;
    }
  }
}
</style>
